<bn-brightnav-layout>
  <bn-client-list column1 [collapsed]="collapsed()" />
  <div column2 class="flex flex-col flex-1 min-h-0 min-w-0 overflow-hidden h-full">
    @if (contentPanelCollapsed()) {
      <!-- Content panel collapsed to left strip; right side is chat or chat strip -->
      <div class="flex flex-row flex-1 min-h-0 min-w-0">
        <div class="bn-content-collapsed-strip">
          <button
            type="button"
            class="bn-copilot-strip-btn"
            (click)="toggleContentPanel()"
            aria-label="Expand content"
          >
            <i class="pi pi-angle-right"></i>
          </button>
          @if (activeTabItem(); as tab) {
            <i [class]="tab.icon + ' bn-content-strip-icon'" aria-hidden="true"></i>
            <span class="bn-content-strip-label">{{ tab.label }}</span>
          }
        </div>
        @if (copilotCollapsed()) {
          <div class="bn-both-collapsed-fill flex-1 min-w-0 min-h-0"></div>
          <div class="bn-copilot-collapsed-strip">
            <button
              type="button"
              class="bn-copilot-strip-btn"
              (click)="toggleCopilot()"
              aria-label="Expand copilot chat"
            >
              <i class="pi pi-angle-left"></i>
            </button>
            <i class="pi pi-microchip-ai bn-copilot-strip-icon" aria-hidden="true"></i>
            <span class="bn-content-strip-label">{{ copilotPanelLabel() }}</span>
          </div>
        } @else {
          <div class="flex-1 min-w-0 min-h-0 flex flex-col">
            <div class="bn-chat-pane-header flex items-center justify-between border-b border-surface-200 bg-transparent px-2 py-1">
              <h2 class="bn-chat-pane-header__title flex items-center gap-2 text-sm font-medium text-surface-700 m-0">
                <i class="pi pi-microchip-ai" aria-hidden="true"></i>
                {{ copilotPanelLabel() }}
              </h2>
              <div class="bn-chat-pane-header__actions">
                <lib-connector-status
                  [agentIdentifier]="selectedAgentIdentifier()"
                  [compact]="true"
                />
                <button
                  type="button"
                  class="bn-copilot-strip-btn"
                  (click)="toggleCopilot()"
                  aria-label="Collapse chat"
                >
                  <i class="pi pi-angle-right"></i>
                </button>
              </div>
            </div>
            <lib-chat
              class="min-w-0 w-full flex-1 min-h-0"
              [showConnectorStatus]="false"
            />
          </div>
        }
      </div>
    } @else if (copilotCollapsed()) {
      <!-- Content expanded, chat collapsed: content fills width, narrow strip on right -->
      <div class="flex flex-row flex-1 min-h-0 min-w-0">
        <bn-fa-client-info-panel
          class="flex-1 min-w-0"
          [tabs]="tabItems()"
          [activeTabId]="activeTab()"
          [mandatoryTabIds]="faMandatoryTabIds()"
          [clientGuid]="selectedClientGuid()"
          [clientName]="selectedClientName()"
          (tabSelect)="onTabSelect($event)"
          (collapseContent)="toggleContentPanel()"
          (defaultCountChange)="reviewDefaultCount.set($event)"
        />
        <div class="bn-copilot-collapsed-strip">
          <button
            type="button"
            class="bn-copilot-strip-btn"
            (click)="toggleCopilot()"
            aria-label="Expand chat"
          >
            <i class="pi pi-angle-left"></i>
          </button>
          <i class="pi pi-microchip-ai bn-copilot-strip-icon" aria-hidden="true"></i>
          <span class="bn-content-strip-label">{{ copilotPanelLabel() }}</span>
        </div>
      </div>
    } @else {
      <p-splitter
        [panelSizes]="[30, 70]"
        [minSizes]="[15, 30]"
        layout="horizontal"
        stateKey="bn-fa-app-content-splitter"
        stateStorage="local"
        styleClass="bn-content-splitter border-0 flex-1 min-h-0"
      >
        <ng-template #panel>
          <bn-fa-client-info-panel
            [tabs]="tabItems()"
            [activeTabId]="activeTab()"
            [mandatoryTabIds]="faMandatoryTabIds()"
            [clientGuid]="selectedClientGuid()"
            [clientName]="selectedClientName()"
            (tabSelect)="onTabSelect($event)"
            (collapseContent)="toggleContentPanel()"
            (defaultCountChange)="reviewDefaultCount.set($event)"
          />
        </ng-template>
        <ng-template #panel>
          <div class="h-full w-full min-h-0 flex flex-col">
            <div class="bn-chat-pane-header flex items-center justify-between border-b border-surface-200 bg-transparent px-2 py-1">
              <h2 class="bn-chat-pane-header__title flex items-center gap-2 text-sm font-medium text-surface-700 m-0">
                <i class="pi pi-microchip-ai" aria-hidden="true"></i>
                {{ copilotPanelLabel() }}
              </h2>
              <div class="bn-chat-pane-header__actions">
                <lib-connector-status
                  [agentIdentifier]="selectedAgentIdentifier()"
                  [compact]="true"
                />
                <button
                  type="button"
                  class="bn-copilot-strip-btn"
                  (click)="toggleCopilot()"
                  aria-label="Collapse chat"
                >
                  <i class="pi pi-angle-right"></i>
                </button>
              </div>
            </div>
            <lib-chat
              class="min-w-0 w-full flex-1 min-h-0"
              [showConnectorStatus]="false"
            />
          </div>
        </ng-template>
      </p-splitter>
    }
  </div>
</bn-brightnav-layout>
